import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {ExpressCheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import GooglePayGateway from '../gateways/GooglePayGateway';

const settings = getSetting('ppcp_googlepay_data');

const gateway = new GooglePayGateway({
    id: 'ppcp_googlepay',
    cart,
    settings
});

const context = new Context('express_checkout');

const controller = new ExpressCheckoutController({
    id: 'ppcp_googlepay',
    cart,
    context,
    gateway,
    settings
});

controller.initialize();